export default __webpack_public_path__ + "static/media/Authentic-gaming.280b751b.png";